// extracted by mini-css-extract-plugin
export default {"tabDecorator":"PoW2vMn6vv9kmOPCAdV32KpD6Paj+vQZQkha70o1ES8="};